export const NAME_RULE = /^([^!@#$%[\]^_&()~:{}=+"<>?/.,*]*)$/;

export const NAME_RULE_EXTENDED = /^([^!@$[\]%^~={}+"<>?*]*)$/;

export const PAYMENT_COMMENT_RULE = /^([^+~={}?\\|`]*)$/;

export const TAX_ID_RULE = /\b\d{4}\b/g;

export const ACCOUNT_NUMBER_RULE = /^\d+$/;

export const ACCOUNT_NUMBER_6_DIGITS_RULE = /\b\d{6}\b/g;

export const EMAIL_RULE = /^\S+@\S+\.\S+/;

export const PASSWORD_RULE = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{10,30}$/;

export const PHONE_RULE = /^[()]\d{3}[)] \d{3}-\d{4}$/;

export const PHONE_MASK_RULE = ["(", /[0-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

export const SECURITY_CODE_RULE = /\d-\d-\d-\d-\d-\d$/;

export const SECURITY_CODE_MASK_RULE = [/\d/, "-", /\d/, "-", /\d/, "-", /\d/, "-", /\d/, "-", /\d/];

export const SSN_INPUT_MASK_RULE = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

export const SSN_INPUT_RULE = /\d{3}-\d{2}-\d{4}$/;

export const EIN_INPUT_MASK_RULE = [/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const EIN_INPUT_RULE = /\d{2}-\d{7}$/;

export const ZIP_INPUT_RULE = /^[a-zA-Z0-9- ]*$/;

export const US_ZIP_INPUT_RULE = /^\d{5}(-\d{4})?$/;

export const DAY_OF_MONTH_RULE = /^([1-9]|[1-2][0-9]|3[0-1])$/;
